import { toast } from "react-toastify";

export const notifyError = (message) => {
  toast.error(message || "Unexpected error");
};
